skrilla.controller('ntrcCtrl', function ($scope, searchService, paginationService, queryService) {
    $scope.key = "ntrc";
    $scope.tabs = [
        {title: "Financials", active: false},
        {title: "Client Ledger", active: false},
        {title: "Bet Ledger", active: false},
    ];

    $scope.reset = function () {
        $scope.query = {
            userId: "",
            accountId:"",
            limit: 20
        };
        $scope.queryXero = {
            firstDate: new Date()
        }
    };
    $scope.reset();



    $scope.searchFinancials = function () {
        paginationService.resetPage($scope.pageKey);
        paginationService.pageQuery(getFinancials, $scope.pageKey);
    }

    let getFinancials = function() {
        return searchService.get("ntrcFinancials" + queryService.getQueryString($scope.query, $scope.pageKey)).then(function (response) {
            $scope.financials = response.data.result;
            paginationService.setPage($scope.pageKey, paginationService.buildPage(response));
        });
    }
});